import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import * as R from "ramda";

import colorContrast from "color-contrast";
import logo_hr from "../../../../../../assets/images/brand/assista_horizontal-punchout.svg";
import logo from "../../../../../../assets/images/brand/assista.svg";

export const Navbar = ({ user, deceasedUser, relocationDeclaration, partnerColor, logoContent, setOnboardingStep, onBoardingStep }) => {
	const router = useSelector((state) => state.router);
	const isFirefox = typeof InstallTrigger !== "undefined";
	const colorCustom = !R.isNil(partnerColor) && partnerColor !== "" ? (colorContrast("#fff", partnerColor) >= 2.5 ? " text-white navbar-dark" : " navbar-light") : " text-white navbar-dark";
	const logo = R.isNil(logoContent) ? logo_hr : logoContent;

	useEffect(() => {
		if (!R.isNil(onBoardingStep)) {
			setOnboardingStep(1);
		}
	}, []);

	return (
		<header className={"aside navbar navbar-expand-lg text-white py-4 py-gd-sm navbar-dark" + (isFirefox ? " pb-lg-0" : " pt-lg-5") + colorCustom}>
			<div className="container-fluid px-gutter justify-content-between align-item-center d-lg-flex flex-lg-column h-100">
				<Link className="navbar-brand mr-lg-auto" to={`/facilita`}>
					<img className={"img-fluid" + (logoContent ? " rounded-sm img-avatar" : "")} src={logo} alt={"Assist@" + (logoContent ? " Partner" : "")} height="80" width="212" onError={(ev) => (ev.target.src = logo_hr)} />
					<h1 className="sr-only visually-hidden">Assist@: Menu</h1>
				</Link>
				<section className={"d-none d-lg-block container-narrow mb-5"}>
					<h2 className="h2 font-weight-bolder mb-gutter_sm">Déclarer un déménagement</h2>
				</section>
				<div className="d-flex align-items-center">
					<button className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
						<span className="navbar-toggler-icon"></span>
					</button>
				</div>
				<div className={"collapse navbar-collapse flex-column mt-3 mt-lg-0"} id="navbar-collapse">
					<nav className="card w-100 rounded-cta bg-stage flex-grow-0 mb-4 mb-gd-0 h-100 border-0">
						<h1 className="sr-only visually-hidden">Menu: navigation</h1>
						<div className="nav-item show">
							<ul className="card-body navbar-nav">
								<li
									type="button"
									onClick={() => {
										setOnboardingStep(1);
									}}
									className={"nav-item" + (relocationDeclaration?.onBoardingStep > 1 ? " done" : "") + (onBoardingStep == 1 ? " active text-white" : "")}>
									<div className="nav-link d-flex w-100 justify-content-between mb-0">
										<span className="align-middle">Compléter les informations</span>
										<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
										<div className="done-check mr-n4 h3 p-2 px-3 my-auto">
											<i className="icn-done eva eva-checkmark-circle-outline"></i>
										</div>
									</div>
								</li>
							<hr className="my-0 w-100" style={{ borderTopColor: "hsla(0,0%,100%,.15)" }} />
								<li
									type="button"
									onClick={() => {
										if (relocationDeclaration?.onBoardingStep < 2) {
											return;
										}
										setOnboardingStep(2);
									}}
									className={"nav-item" + (relocationDeclaration?.onBoardingStep > 2 ? " done" : "") + (onBoardingStep == 2 ? " active text-white" : "")}>
									<div className="nav-link d-flex w-100 justify-content-between mb-0">
										<span className="align-middle">Valider les informations</span>
										<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
										<div className="done-check mr-n4 h3 p-2 px-3 my-auto">
											<i className="icn-done eva eva-checkmark-circle-outline"></i>
										</div>
									</div>
								</li>
							<hr className="my-0 w-100" style={{ borderTopColor: "hsla(0,0%,100%,.15)" }} />
								<li
									type="button"
									onClick={() => {
										if (relocationDeclaration?.onBoardingStep < 3) {
											return;
										}
										setOnboardingStep(3);
									}}
									className={"nav-item" + (relocationDeclaration?.onBoardingStep > 3 ? " done" : "") + (onBoardingStep == 3 ? " active text-white" : "")}>
									<div className="nav-link d-flex w-100 justify-content-between mb-0">
										<span className="align-middle">Aides et allocations</span>
										<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
										<div className="done-check mr-n4 h3 p-2 px-3 my-auto">
											<i className="icn-done eva eva-checkmark-circle-outline"></i>
										</div>
									</div>
								</li>
							<hr className="my-0 w-100" style={{ borderTopColor: "hsla(0,0%,100%,.15)" }} />
								<li
									type="button"
									onClick={() => {
										if (relocationDeclaration?.onBoardingStep < 4) {
											return;
										}
										setOnboardingStep(4);
									}}
									className={"nav-item" + (relocationDeclaration?.onBoardingStep > 4 ? " done" : "") + (onBoardingStep == 4 ? " active text-white" : "")}>
									<div className="nav-link d-flex w-100 justify-content-between mb-0">
										<span className="align-middle">Signature</span>
										<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
										<div className="done-check mr-n4 h3 p-2 px-3 my-auto">
											<i className="icn-done eva eva-checkmark-circle-outline"></i>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</div>
		</header>
	);
};
